import moment from "moment";

import { InfoFormItem, PageFormItem } from "../../components";

export const createCancelAppointmentBranch = (now: string): PageFormItem<InfoFormItem> => {
    const callToday = moment(now).hours() < 20;
    const timeToCall = callToday ? "i dag" : "i morgen";

    return {
        type: "page",
        title: "Aflys besøg og aftal et nyt",
        item: {
            type: "info",
            render: "default",
            text: `
                Vi informerer ikke kunden, når du aflyser dit besøg. Derfor er det vigtigt, at du selv gør det.<br />
                <br />
                Vi forventer at du <strong>ringer til kunden ${timeToCall}</strong> for at aftale et besøg.<br />
                <br />
                Du vil se en “Har I lavet en aftale?”-opgave på din oversigt. Gå ind på opgaven for at besvare den, når du har ringet til kunden.
                ${callToday ? "" : `
                    <br />
                    <br />
                    Vi minder dig om opgaven med en sms på dagen.
                `}
            `,
        }
    };
};
